import { clamp } from "@utils/number-utils";

export const getPercentRatio = (numberInPercent: number): number => {
	const roundNumber = Math.round(numberInPercent);
	let ratio = 0;
	if (numberInPercent === 100) {
		ratio = 1;
	} else if (numberInPercent !== 0) {
		ratio = clamp(roundNumber / 100, 0.01, 0.99);
	}

	return ratio;
};
